import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createChild, createChildInfo, createMeal, deleteChildInfo, fetchAllChildList, fetchChildGuardian, fetchChildrenById, fetchChildrenList, fetchInactiveChildrenList, fetchMealsPlan, fetchMealsPlanRoom, fetchRelationType, fetchWaitingChildrenList, UpdateChildInfo, UpdateChildrenInfo, UpdateChildStatus, } from "../../../service/api";




export const getChild = createAsyncThunk(
    "child/getChild",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchChildrenList(params)
            console.log("child plan", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getInactiveChild = createAsyncThunk(
    "child/inactive",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchInactiveChildrenList(params)
            console.log("child plan", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getWaitingChild = createAsyncThunk(
    "child/waiting",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchWaitingChildrenList(params)
            console.log("child plan", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getAllChild = createAsyncThunk(
    "child/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchAllChildList(params)
            console.log("child all", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)
export const getChildGuardian = createAsyncThunk(
    "child/getGuardian",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchChildGuardian(params)
            console.log("child guardian", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getChildById = createAsyncThunk(
    "childById/getId",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchChildrenById(params)
            console.log("child info", response)
            if (response.status === 202) {
                console.log("child without page")
                return response.data
            } else {
                console.log("child with page")
                return response.data.data
            }
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getRelationType = createAsyncThunk(
    "relation-type/getRelation",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchRelationType(params)
            console.log("relation type", response)

            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const addChild = createAsyncThunk(
    "child/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createChild(formValue)
            if (response.status === 201) {
                console.log("child add", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const editChildData = createAsyncThunk(
    "child/edit",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await UpdateChildInfo(formValue)
            if (response.status === 201) {
                console.log("edit child ", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const editChildrenStatus = createAsyncThunk(
    "child/editStatus",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await UpdateChildStatus(formValue)
            if (response.status === 201) {
                console.log("edit child ", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const editChildrenInfo = createAsyncThunk(
    "childInfo/edit",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await UpdateChildrenInfo(formValue)
            if (response.status === 201) {
                console.log("edit child info ", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)
export const addChildInfo = createAsyncThunk(
    "childInfo/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createChildInfo(formValue)
            if (response.status === 201) {
                console.log("child info", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)



export const DeleteChildInfo = createAsyncThunk(
    "childInfo/delete",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await deleteChildInfo(formValue)
            if (response.status === 201) {
                console.log("child info", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


const childSlice = createSlice({
    name: "children",
    initialState: {
        childrenList: [],
        inactiveChildrenList: [],
        waitChildrenList: [],
        relationTypeList: [],
        childById: [],
        childGuardian: {},
        allChildList: [],
        defaultRoomId: null,
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        inactiveTotalPage: 0,
        waitTotalPage: 0,
        current: 1,
        limit: 10,
        searchParams: "",
        room: "",
        dob: "",
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
        setRoomFilter: (state, action) => {
            state.room = action.payload;
        },
        setDobFilter: (state, action) => {
            state.dob = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getChild.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getChild.fulfilled, (state, action) => {
                state.isLoading = false;
                state.childrenList = action.payload.data;
                state.totalPage = action.payload.totalPage
            })
            .addCase(getChild.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //INACTIVE CHILD
            .addCase(getInactiveChild.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getInactiveChild.fulfilled, (state, action) => {
                state.isLoading = false;
                state.inactiveChildrenList = action.payload.data;
                state.inactiveTotalPage = action.payload.totalPage
            })
            .addCase(getInactiveChild.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //WAIT
            .addCase(getWaitingChild.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getWaitingChild.fulfilled, (state, action) => {
                state.isLoading = false;
                state.waitChildrenList = action.payload.data;
                state.waitTotalPage = action.payload.totalPage
            })
            .addCase(getWaitingChild.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //guardian

            .addCase(getChildGuardian.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getChildGuardian.fulfilled, (state, action) => {
                state.isLoading = false;
                state.childGuardian = action.payload.data;
            })
            .addCase(getChildGuardian.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //all child

            .addCase(getAllChild.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getAllChild.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allChildList = action.payload.data;
                state.totalPage = action.payload.totalPages
            })
            .addCase(getAllChild.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //relation type 
            .addCase(getRelationType.pending, (state) => {
                state.error = null
            })
            .addCase(getRelationType.fulfilled, (state, action) => {
                state.relationTypeList = action.payload.data;
            })
            .addCase(getRelationType.rejected, (state, action) => {
                state.error = action.payload
            })


            //by id
            .addCase(getChildById.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(getChildById.fulfilled, (state, action) => {
                state.isLoading = false
                state.childById = action.payload.data;

            })
            .addCase(getChildById.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })

            // POST
            .addCase(addChildInfo.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addChildInfo.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addChildInfo.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // PUT
            .addCase(editChildData.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editChildData.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editChildData.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT STATUS
            .addCase(editChildrenStatus.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editChildrenStatus.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editChildrenStatus.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT Chil Info
            .addCase(editChildrenInfo.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editChildrenInfo.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editChildrenInfo.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // POST
            .addCase(addChild.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addChild.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addChild.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // Delete
            .addCase(DeleteChildInfo.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(DeleteChildInfo.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(DeleteChildInfo.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

    }
})
export const { setSearchParams, setPagination, setRoomFilter, setDobFilter } = childSlice.actions;

export default childSlice.reducer;